export const FETCH_BUCKET_DATA_REQUEST = 'FETCH_BUCKET_DATA_REQUEST'
export const FETCH_BUCKET_DATA_SUCCESS = 'FETCH_BUCKET_DATA_SUCCESS'
export const FETCH_BUCKET_DATA_FALIURE = 'FETCH_BUCKET_DATA_FALIURE'
